@if (!isCheckoutPage) {
  <strong
  style="font-size: 20px;margin-left: 4px">{{'client.address.address' | translate}}</strong>
}

@if (address) {
  <div class="tw-padding-10">
    <span>{{address.company}}</span>
    <div>
      @if (address.appartment) {
        <span>
          {{address.appartment}}
          <svg height="5" width="8">
            <line x1="0" y1="0" x2="8" y2="0" style="stroke:black;stroke-width:3"></line>
          </svg>
        </span>
      }
      {{address.addressLine1}}
    </div>
    <div>{{address.addressLine2}}  </div>
    <span>{{address.city}}  </span>
    <span>{{address.province}}  </span>
    <span>{{address.zipCode.toUpperCase()}} </span><br>
    <span>{{address.country}} </span>
  </div>
}
